import { render, staticRenderFns } from "./warn_board.vue?vue&type=template&id=4600b39f&scoped=true&"
import script from "./warn_board.vue?vue&type=script&lang=js&"
export * from "./warn_board.vue?vue&type=script&lang=js&"
import style0 from "./warn_board.vue?vue&type=style&index=0&id=4600b39f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4600b39f",
  null
  
)

export default component.exports